import React, { createContext, useMemo, ReactNode } from "react";
import { IUserPractice, IUserSite } from "../models/PracticeAssignment";

interface Practice {
  practiceId?: number;
  practiceName?: string;
  displayName?: string;
}

interface SiteDetail {
  name?: string;
  displayName?: string;
}

interface Site {
  siteId?: number;
  siteDetail?: SiteDetail;
}

interface SiteContextType {
  currentPracticeDetails: Practice | null;
  currentSite: Site | null;
  currentStationName: string;
  isValidSite: boolean;
  isValidPractice: boolean;
  allyOnlyPractices: IUserPractice[];
  getSitesByPracticeId: (
    isUserAllyOnlyRole: boolean,
    practice: IUserPractice,
  ) => Promise<IUserSite[] | undefined>;
}

// eslint-disable-next-line react-refresh/only-export-components
export const SiteContext = createContext<SiteContextType>({
  currentPracticeDetails: null,
  currentSite: null,
  currentStationName: "",
  isValidSite: false,
  isValidPractice: false,
  allyOnlyPractices: [],
  getSitesByPracticeId: async () => undefined,
});

interface SiteProviderProps {
  children: ReactNode;
}

export const SiteProvider: React.FC<SiteProviderProps> = ({ children }) => {
  // For now, provide default/empty values
  // This can be populated from API or user context later if needed
  const contextValue = useMemo<SiteContextType>(
    () => ({
      currentPracticeDetails: null,
      currentSite: null,
      currentStationName: "",
      isValidSite: false,
      isValidPractice: false,
      allyOnlyPractices: [],
      getSitesByPracticeId: async () => undefined,
    }),
    [],
  );

  return (
    <SiteContext.Provider value={contextValue}>{children}</SiteContext.Provider>
  );
};
